module.exports = __webpack_public_path__ + "img/AUS.8892e6db.svg";